import * as Yup from 'yup';

export const setAsEmail = (valObj) => {
    let emailVal = Yup.string().email('not a valid email');
    valObj = valObj.concat(emailVal);
  return valObj;
};

export const setRequired = (valObj, qObj) => {
  const is_required = qObj.is_required;
  if (typeof is_required !== 'undefined') {
    const reqVal = Yup.string().required('REQUIRED *');
    valObj = valObj.concat(reqVal);
  }
  return valObj;
};
export const setCharLimit = (valObj, charLimit) => {
  if (typeof charLimit !== 'undefined') {
    let minVal = Yup.string().min(charLimit, 'Must be at least ' + charLimit + ' characters');
    valObj = valObj.concat(minVal);
  }
  return valObj;
};
export const transformCase = (valObj, qObj) => {
  if (typeof qObj.case !== 'undefined') {
    let caseVal = Yup.string().transform(function(currentValue, prevValue) {
      return this.isType(currentValue) && currentValue !== null
        ? currentValue.toLowerCase() : currentValue;
      // .ToTitleCase() is a custom String extension
    });
    valObj = valObj.concat(caseVal);
  }
  return valObj;
};
